/** 一些需要重复使用的菜单项名称 */
export enum MENU_LABEL {
  LEYOPAY = '结算系统',
  SETTLEMENT = '自助结算',
  VARITY = '我的品种'
}
/** 用于控制路由权限的角色大类名称 */
export enum ROUTE_ROLE_TYPE_NAME {
  MONEY_TREE_ONLY = '摇钱树供应商',
  FIRST_MONEY_BOTH = '首推供应商&摇钱树供应商'
}
